import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ControlContainer} from '@angular/forms';
import {ShortStates} from '../../../../core/classes/state.class';

@Component({
  selector: 'app-geocode-address',
  templateUrl: './geocode-address.component.html',
  styleUrls: ['./geocode-address.component.scss'],
})
export class GeocodeAddressComponent implements OnInit {
  @Input() isSubmitted = false;
  @Input() fromWhichDialog;
  @Input() tribuneData;

  parentGroup: any;
  statesList = [];
  tribuneFlag: boolean;

  constructor(public parentControl: ControlContainer) {}

  ngOnInit(): void {
    this.parentGroup = this.parentControl.control;
    this.statesList = ShortStates;
  }

  stateFilled(event: Event) {
    const target = event.target as HTMLInputElement;
    this.parentGroup.get('state').patchValue(target.value);
  }

  zipFilled(event: Event) {
    const target = event.target as HTMLInputElement;
    const control = this.parentGroup.get('zipcode') || this.parentGroup.get('zipCode')
    control.patchValue(target.value);
  }

  cityKeyPress(event: any) {
    const pattern = /[a-zA-Z. ]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode !== 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  numberOnly(e) {
    let inp = String.fromCharCode(e.keyCode);
    if (/[0-9]/.test(inp)) {
      return true;
    } else {
      e.preventDefault();
      return false;
    }
  }

  @Output() emitter:EventEmitter<string>
       = new EventEmitter<string>();

  emit(zipCode){
      this.emitter.emit(zipCode);
  }
}
